import React__default from 'react';
import { Button } from '../../atoms/Button.js';
import { BankInfo } from '../../molecules/BankInfo/BankInfo.js';
import { TitleGroup } from '../../molecules/TitleGroup.js';
import './ConnectedBankInfo.scss';

const ConnectedBankInfo = ({ bankAccountInfo, onEditBankInfo, className, isLoading, title, }) => {
    return (React__default.createElement("div", { "data-rev-component": 'connected-bank-info', className: className },
        title !== null && (React__default.createElement(TitleGroup, { className: 'connect-bank-title--rev', title: title ?? 'Connected bank info', level: 'subgroup' })),
        React__default.createElement("div", { className: 'connected-bank-info-content--rev' },
            React__default.createElement(BankInfo, { bankName: bankAccountInfo.bankName, accountName: bankAccountInfo.accountName, accountNumberLastDigits: bankAccountInfo.accountNumberLastDigits, bankIconUrl: bankAccountInfo.bankIconUrl, showCheckmarkPlaceholder: true }),
            React__default.createElement(Button, { variant: 'ghost', size: 'small', onPress: onEditBankInfo, className: 'connected-bank-info-edit-button--rev', isLoading: isLoading }, "Edit"))));
};

export { ConnectedBankInfo };
//# sourceMappingURL=ConnectedBankInfo.js.map
